import React, { useState, useEffect } from "react";
import Header from "../Section/Header";
import Footer from "../Section/Footer";
import { useNavigate } from "react-router-dom";
import {
  server_post_data,
  view_subjecsts,
} from "../../ServiceConnection/serviceconnection";
import { Moon } from "lucide-react";
import Loader from "../Section/Loader";
export default function Forum() {
  const navigate = useNavigate();
  const [astrodata, setAstrodata] = useState([]);
  const [categories, setcategories] = useState([]);
  const [imageLink, setImageLink] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleNavigate = () => {
    navigate("/ask-question");
  };

  const fetchAstroData = async () => {
    const formData = new FormData();
    setIsLoading(true);
    formData.append("sub_id", 0);
    formData.append("cat_id", 0);
    formData.append("thread_id", 0);
    formData.append("load_more", 0);
    formData.append("total_load", 0);
    formData.append("flag", 2);

    await server_post_data(view_subjecsts, formData)
      .then(async (Response) => {
        setIsLoading(false);
        let data = Response.split("~@~");
        if (parseInt(data[0]) === 1) {
          console.error(data[1]);
        } else {
          let imageLink = JSON.parse(data[1])[0]["image_category"];
          let get_data_subs = JSON.parse(
            JSON.parse(data[1])[0]["get_data_subs"]
          );
          setAstrodata(get_data_subs);
          const categories = Array.from(
            new Set(get_data_subs.map((item) => item.subjects))
          );
          setcategories(categories);
          setImageLink(imageLink);
        }
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };
  useEffect(() => {
    fetchAstroData();
  }, []);

  const handleNavigate2 = (id) => {
    navigate(`/forum-questions/${id}`);
  };
  console.log("__astrodata__", astrodata);
  return (
    <>
      <Header />
       {isLoading && <Loader />}
      <div className="min-h-screen bg-gradient-to-br from-slate-900 via-purple-900 to-indigo-900 bg-[length:300%_300%] animate-gradient-flow">
        <section
          className="max-w-[1250px] mx-auto py-10
         px-4"
        >
          <div className="text-center mb-8">
            <h2 className="flex  gap-2 items-center mx-auto w-fit text-3xl md:text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-purple-400 to-pink-400 mb-4">
              <Moon color="#c781f3" size={32} strokeWidth={2.2} /> Astro Forum
            </h2>
            <p className="text-lg text-purple-300 mb-6">
              Connect with the astrology community - Ask questions, share
              knowledge, and learn together
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            <div className="space-y-6 mt-[3.3rem] md:sticky top-[5.5rem] h-fit">
              <div className="rounded-lg border bg-card text-card-foreground shadow-sm bg-gradient-to-r from-purple-600 to-pink-600 border-none">
                <div className="p-6 text-center">
                  <h3 className="text-xl font-semibold text-white mb-3">
                    Have a Question?
                  </h3>
                  <p className="text-purple-100 mb-4 text-sm">
                    Get answers from experienced astrologers and community
                    members
                  </p>
                  <button
                    className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&amp;_svg]:pointer-events-none [&amp;_svg]:size-4 [&amp;_svg]:shrink-0 h-10 px-4 py-2 w-full bg-white text-purple-600 hover:bg-gray-100"
                    onClick={handleNavigate}
                  >
                    ❓ Ask a Question
                  </button>
                </div>
              </div>
              <div className="rounded-lg border text-card-foreground shadow-sm bg-slate-800/50 border-purple-500/20 hidden">
                <div className="flex flex-col space-y-1.5 p-6">
                  <h3 className="font-semibold tracking-tight text-lg text-purple-100">
                    🔥 Trending Topics
                  </h3>
                </div>
                <div className="p-6 pt-0">
                  <div className="space-y-2">
                    <button className="inline-flex items-center gap-2 whitespace-nowrap text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&amp;_svg]:pointer-events-none [&amp;_svg]:size-4 [&amp;_svg]:shrink-0 h-9 rounded-md px-3 w-full justify-start text-purple-300 hover:text-purple-100 hover:bg-purple-800/50">
                      #Saturn Transit 2024
                    </button>
                    <button className="inline-flex items-center gap-2 whitespace-nowrap text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&amp;_svg]:pointer-events-none [&amp;_svg]:size-4 [&amp;_svg]:shrink-0 h-9 rounded-md px-3 w-full justify-start text-purple-300 hover:text-purple-100 hover:bg-purple-800/50">
                      #Jupiter in Taurus
                    </button>
                    <button className="inline-flex items-center gap-2 whitespace-nowrap text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&amp;_svg]:pointer-events-none [&amp;_svg]:size-4 [&amp;_svg]:shrink-0 h-9 rounded-md px-3 w-full justify-start text-purple-300 hover:text-purple-100 hover:bg-purple-800/50">
                      #Rahu-Ketu Effects
                    </button>
                    <button className="inline-flex items-center gap-2 whitespace-nowrap text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&amp;_svg]:pointer-events-none [&amp;_svg]:size-4 [&amp;_svg]:shrink-0 h-9 rounded-md px-3 w-full justify-start text-purple-300 hover:text-purple-100 hover:bg-purple-800/50">
                      #Marriage Timing
                    </button>
                    <button className="inline-flex items-center gap-2 whitespace-nowrap text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&amp;_svg]:pointer-events-none [&amp;_svg]:size-4 [&amp;_svg]:shrink-0 h-9 rounded-md px-3 w-full justify-start text-purple-300 hover:text-purple-100 hover:bg-purple-800/50">
                      #Career Dasha
                    </button>
                  </div>
                </div>
              </div>

              <div className="rounded-lg border text-card-foreground shadow-sm bg-slate-800/50 border-purple-500/20 hidden">
                <div className="flex flex-col space-y-1.5 p-6">
                  <h3 className="font-semibold tracking-tight text-lg text-purple-100">
                    👨‍🏫 Online Astrologers
                  </h3>
                </div>
                <div className="p-6 pt-0">
                  <div className="space-y-3">
                    <div className="flex items-center space-x-2">
                      <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                      <span className="text-purple-300 text-sm">
                        Pandit Sharma
                      </span>
                    </div>
                    <div className="flex items-center space-x-2">
                      <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                      <span className="text-purple-300 text-sm">Dr. Meera</span>
                    </div>
                    <div className="flex items-center space-x-2">
                      <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                      <span className="text-purple-300 text-sm">
                        Acharya Das
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="lg:col-span-2 space-y-6">
              {categories &&
                categories.length > 0 &&
                categories.map((item_main, index_main) => (
                  <div key={index_main}>
                    <h3 className="text-2xl font-semibold text-purple-200 mb-4">
                      {item_main}
                    </h3>

                    <div className="grid grid-cols-1 md:grid-cols-2  gap-6">
                      {astrodata &&
                        astrodata
                          .filter((item) => item.subjects === item_main)
                          .map((item, index) => (
                            <div
                              key={index}
                              onClick={() => handleNavigate2(item.cat_id)}
                              className="bg-gradient-to-br from-[#1e1b4b] via-[#2e1065] to-[#1e1b4b] rounded-lg border border-purple-600/30 hover:border-purple-400/70 hover:shadow-lg shadow-purple-500/20 transition-all duration-300 hover:scale-[1.03] p-4 cursor-pointer"
                            >
                              <div className="flex flex-col justify-between h-full space-y-4">
                                {/* Top Content */}
                                <div>
                                  <div className="flex items-center gap-[5px] mb-1">
                                    <img
                                      className="h-[32px] w-[32px]"
                                      src={imageLink + item.images}
                                      alt={item.cat_data}
                                    />
                                    <h3 className="text-xl font-bold text-white mb-0">
                                      {item.cat_data}
                                    </h3>
                                  </div>

                                  <p className="text-sm text-purple-300">
                                    {item.cat_desc}
                                  </p>
                                </div>

                                {/* Bottom Content */}
                                <div className="flex justify-between items-end pt-3 border-t border-white/10 mt-4">
                                  <div className="text-sm text-[var(--light-pink-color)]">
                                    Replies:
                                    <span className="ml-1 text-purple-200 font-semibold">
                                      {item.total_message}
                                    </span>
                                  </div>
                                  <div className="text-sm text-[var(--light-pink-color)]">
                                    Comments:
                                    <span className="ml-1 text-purple-200 font-semibold">
                                      {item.total_message}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))}
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </>
  );
}
